module.exports = __webpack_public_path__ + "img/v8.830a6614.png";